import { EditModal } from "@/components/EditModal"
import { NozzleSim, NozzleTable } from "./NozzleTable"
import { EditOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"
import {sum, isObject} from 'lodash-es'
import styles from './styles.module.less'
import classNames from "classnames"
import { numberFixTo } from "../utils"
import { useSelector } from "react-redux"
import { RunState, getStatus } from "@/store/flowsheet/flowsheet.slice"

interface EditNozzleTableProps {
  data: NozzleSim[]
  onSave: (value: number[]) => void
  onDelete: (index: number) => void
}

export const EditNozzleTable = (props: EditNozzleTableProps) => {
  const {data, onSave, onDelete} = props
  const status = useSelector(getStatus)
  const initVal = data.map(item => isObject(item.eta) ? item.eta.val : (item.eta) )
  const [value, setValue] = useState<number[]>(initVal as number[])
  const total = numberFixTo(sum(value.map(item => item || 0)))

  useEffect(() => {
    const newVal = data.map(item => isObject(item.eta) ? item.eta.val : (item.eta) )
    setValue(newVal as number[])
  }, [data])

  const saveChanges = () => {
    onSave(value as number[])
  }

  const onChange = (val: number[]) => {
    setValue(val)
  }
  return <EditModal title="Edit Split Ratio"
    trigger={status !== RunState.Stop && <EditOutlined />}
    onOk={saveChanges}>
    <NozzleTable readonly={false} data={data} onChange={onChange} onDelete={onDelete}/>
    <div className="mt-1 flex-end">Total: <div className={classNames(styles.totalFraction, total !== 1 && styles.errorStatus)}>{total}</div></div>
    
  </EditModal>
}